var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58.49 58.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a69cf4d4-682d-474a-b94e-90168560c307,.aeb3cb86-d3c5-4d89-8a78-d628f00114be{fill:none;stroke:#1a1a1a;stroke-miterlimit:10;}.aeb3cb86-d3c5-4d89-8a78-d628f00114be{stroke-width:1.27px;}.a69cf4d4-682d-474a-b94e-90168560c307{stroke-width:0.92px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b121ba98-9cf1-4c1f-a5ba-1ef66efead6b",
    "data-name": "\\u5716\\u5C64 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b3449394-10da-4b39-978a-b942aaf30784",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "aeb3cb86-d3c5-4d89-8a78-d628f00114be",
    cx: 29.24,
    cy: 29.24,
    r: 28.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "a69cf4d4-682d-474a-b94e-90168560c307",
    points: "30.11 13.64 43.6 21.81 16.55 21.87 30.11 13.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a69cf4d4-682d-474a-b94e-90168560c307",
    d: "M44.74,37h0a2.62,2.62,0,0,1-2.62,2.62h-24A2.61,2.61,0,0,1,15.49,37V23.22a2.28,2.28,0,0,1,0-.45l13.8,8.61.05,0,.06,0a1.21,1.21,0,0,0,.3.11h0a1.32,1.32,0,0,0,.34,0h0a1.39,1.39,0,0,0,.35,0h0a1.21,1.21,0,0,0,.3-.11l.05,0,.05,0L44.7,22.77a3.42,3.42,0,0,1,0,.45Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email_icon.3fb5efbc603b5c715d8e1db2b4094d40.svg";
export { ForwardRef as ReactComponent };